import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

export function useAssetIpTableColumns() {
  const { t } = useTranslation('ads');

  return useMemo(
    () => [
      t('assetDetails.ipTable.columns.name'),
      t('assetDetails.ipTable.columns.ipAddress'),
      t('assetDetails.ipTable.columns.macAddress'),
    ],
    [t],
  );
}
